export const stripLinesReportLayout = [
  { label: 'Por empresa', value: 1 },
  { label: 'Por localidade', value: 2 },
  { label: 'Linhas canceladas', value: 3 },
]

export const situacoesLinha = [
  { label: "Ativas", value: 1 },
  { label: "Inativas", value: 2 },
  { label: "Todas", value: 3 }
];
